module.exports = __webpack_public_path__ + "img/benefit-6.8138437f.png";